import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ChipTimeChipPickerLabels } from '@sb/library/base';
import { FormFieldTimeComponent } from '@sb/library/form-field';
import { SBTime } from '@sb/library/localization';
import { MbscDateType, MbscDatepicker } from '@mobiscroll/angular';

@Component({
    selector: 'lib-chip-time-range-picker-panel',
    templateUrl: './chip-time-range-picker-panel.component.html',
    styleUrls: ['./chip-time-range-picker-panel.component.scss']
})
export class ChipTimeRangePickerPanelComponent extends FormFieldTimeComponent {

    @ViewChild(MbscDatepicker, {static: true}) datePicker!: MbscDatepicker;

    @Output() timeChange: EventEmitter<(SBTime | null)[]> = new EventEmitter();
    @Output() closePanel: EventEmitter<null> = new EventEmitter();

    private _startTime: SBTime | null = null;
    private _endTime: SBTime | null = null;
    private _manualInput: boolean = true;

    private _labels: ChipTimeChipPickerLabels = new ChipTimeChipPickerLabels;

    @Input()
    set endTime(value: SBTime | null) {
        this._endTime = value;
    }

    @Input()
    set startTime(value: SBTime | null) {
        this._startTime = value;
    }

    @Input()
    set labels(value: ChipTimeChipPickerLabels) {
        this._labels = value;
    }

    ngAfterViewInit(): void {
        const changeActiveSelect = this.datePicker._changeActiveSelect.bind(this.datePicker);
        this.datePicker._changeActiveSelect = ev => {
            // Patch to make sure if the start time is unset, it doesn't use the "current" time as the limit
            // for the end time (i.e., the end time is not restricted to times after the fake start time)
            if (this.datePicker._activeSelect == 'start') {
                if (this._endTime && !this._startTime) {
                    this.datePicker.setTempVal([this._endTime.ToISO(), this._endTime.ToISO()]);
                    this.datePicker._tempStartText = this.labels.StartHelperText;
                }
            } else {
                if (this._startTime && !this._endTime) {
                    this.datePicker.setTempVal([this._startTime.ToISO(), this._startTime.ToISO()]);
                    this.datePicker._tempEndText = this.labels.EndHelperText;
                }
            }

            changeActiveSelect(ev);
        }

        this.UpdateDatePicker(false);
    }

    Clicked(event: any) {
        event.stopPropagation();

        // Force update if the user has clicked the time that was already selected
        if (event.target?.classList) {
            const classList = [...event.target.classList];
            if (classList.indexOf('mbsc-selected') < classList.indexOf('mbsc-active')) {
                this.TimeChanged();
            }
        }
    }

    TimeChanged(): void {
        if (this._manualInput) {
            const value = this.datePicker.getTempVal() as MbscDateType[];
            if (this.datePicker._activeSelect == 'start') {
                this._startTime = value[0] ? SBTime.FromJSDate(value[0] as Date) : null;
            }
            this._endTime = value[1] ? SBTime.FromJSDate(value[1] as Date) : null;

            this.UpdateStartEndTime(this._startTime, this._endTime);
        } else {
            this.UpdateDatePicker();
        }
    }

    UpdateStartEndTime(startTime: SBTime | null, endTime: SBTime | null, manual = true): void {
        this._startTime = startTime;
        this._endTime = endTime;
        this.timeChange.emit([this._startTime, this._endTime]);

        this.UpdateDatePicker(manual);
    }

    UpdateDatePicker(manual = true): void {
        if (!manual) {
            this._manualInput = false;
            setTimeout(() => this._manualInput = true, 250);
        }

        this.datePicker.setVal([this._startTime ? this._startTime.ToISO() : null, this._endTime ? this._endTime.ToISO() : null]);

        this.datePicker._tempStartText = this._startTime ? this._startTime.Render('short') : this.labels.StartHelperText;
        this.datePicker._tempEndText = this._endTime ? this._endTime.Render('short') : this.labels.EndHelperText;
    }

    ResetTimeRange(): void {
        this.datePicker._activeSelect = 'start';
        this.UpdateStartEndTime(null, null, false);
    }

    ApplyClicked(): void {
        this.closePanel.emit();
    }

    get startSBTime(): SBTime | null {
        return this._startTime;
    }

    get endSBTime(): SBTime | null {
        return this._endTime;
    }

    get labels(): ChipTimeChipPickerLabels {
        return this._labels;
    }
}
